export default __webpack_public_path__ + "static/media/ic-prior-fallow.1e782f3e.svg";